import * as Yup from "yup";

export function getStandardIdValidation(overrides) {
  return {
    dataField: "id", dataLabel: "Id", readOnly: true, hideOnCreate: true,
    ...overrides
  };
}

export function getStandardActiveValidationLegacy(overrides) {
  return{
    dataField: "active", dataLabel: "Active", hideOnCreate: true, createValue: true, readOnly: false,
    type: "select", selectOptions: [{value: "true", text: "Active"}, {value: "false", text: "Deactivated"}],
    yup: Yup.string()
    .required("Active must have a value set")
  };
}
export function getStandardActiveValidation(overrides) {
  return {
    dataField: "active", dataLabel: "Active", hideOnCreate: true, createValue: true, readOnly: false,
    type: "switch",
    trueLabel: "Is active",
    falseLabel: "Is not active",
    switchColour: "success",
    yup: Yup.string()
      .required("Active must have a value set"),
    ...overrides
  };
}

export function getBankAccountFilterFieldsValidation(overrides) {
  return {
    dataField: "field", dataLabel: "label", hideOnCreate: true, createValue: true, readOnly: false,
    type: "switch",
    trueLabel: "Validation Required",
    falseLabel: "Validation Not Required",
    switchColour: "success",
    yup: Yup.string()
    .required("Flag must have a value set"),
    ...overrides
  };
}

export function getStandardDeleteValidation(overrides) {
  return {
    dataField: "deleted", dataLabel: "Deleted",
    hideOnCreate: true, createValue: false, readOnly: false,
    type: "switch",
    trueLabel: "Has been deleted",
    falseLabel: "Has not been deleted",
    switchColour: "danger",
    yup: Yup.string()
      .required("Deleted must have a value set"),
    ...overrides
  };
}



export function getGenericValidation(overrides) {
  return {
    ...overrides
  };
}



// WEBPACK FOOTER //
// ./src/utils/ValidationTemplate.js